import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from "./MapPopupStyles.js";
import Tooltip from '@material-ui/core/Tooltip';
import "./style.scss";
import { getFormattedDeliveryWindowList, getDeliveryWindowByEarlyAndLateCTA } from "../../dataGrid/gridUtilities";
import { getCombinedIconsArray, getIconByType } from "./PopupUtil";

function ShipmentPopupInfo(props){
  const { classes, theme } = props;
  
  const address = props.data.isDelivery
    ? props.data.consigneeAddress
    : props.data.shipperAddress;
  const city = props.data.isDelivery ? props.data.city : props.data.shipperCity;
  const combinedAddress = `${address}, ${city}`;
  const combinedIconsArray = getCombinedIconsArray(props.data, props.specialNeedsOptions);
  const name = props.data.isDelivery ? props.data.consigneeName : props.data.shipperName;
  const params = {
    data:{
      priority:props.data.priority,
      apt: props.data.apt
    },
    value:props.data.deliveryWindow
  }
  return(
    <Paper className={`${classes.root} popupBGColor`}>
      <Table className={classes.table} padding="none">
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.tableHeadHeight}>
            <TableCell colSpan={2} className={classes.tableHeaderCell}>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={name}>
                <div className={classes.customerName}>
                  {name}
                </div>
              </Tooltip>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={props.data.routeName}>
                <span className={classes.routeInfo}>
                  {props.data.routeName}
                </span>
              </Tooltip>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={combinedAddress}>
                <div className={classes.address}>{combinedAddress}</div>
              </Tooltip>
                <div className={classes.popupIconContainer}>             
                  {combinedIconsArray.slice(0, 5).map(element => <Tooltip key={element.value} classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={element.tooltip}>
                    <div className={classes.popupIcon}>{getIconByType(element)}</div>
                  </Tooltip>)}
                </div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.firstTableCell} tableCellName`}>Pro ID</TableCell>
            <TableCell className={`${classes.dataCell} ${classes.firstTableCell} tableCellValue`}>
              {props.data.proId}
            </TableCell>
          </TableRow>
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}>Service Window</TableCell>
            <TableCell className={`${classes.dataCell} tableCellValue`}>
            {
              getDeliveryWindowByEarlyAndLateCTA(props.data) ||
                getFormattedDeliveryWindowList(params).map((deliverySlot, index) => <React.Fragment key={index}><span>{deliverySlot}</span><br /></React.Fragment>)
            }
            </TableCell>
          </TableRow>
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} ${props.data.shipmentSpecialInstruction ? '' : classes.lastTableCell} tableCellName`}>
              <div className={classes.dualCellLeft}>
                Weight
              </div>
              <div className={classes.dualCellRight}>
                  PSE
              </div>
            </TableCell>
            <TableCell className={`${classes.dataCell} ${props.data.shipmentSpecialInstruction ? '' : classes.lastTableCell} tableCellValue`}>
              <div className={classes.dualCellLeft}>
              {props.data.weight} lbs
              </div>
              <div className={classes.dualCellRight}>
                {props.data.pse}
              </div>
            </TableCell>
          </TableRow>
          {props.data.shipmentSpecialInstruction &&
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}>Special Instructions</TableCell>
            <TableCell className={`${classes.dataCell} ${classes.lastTableCell} tableCellValue`}>
              <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={props.data.shipmentSpecialInstruction}>
                <div className={classes.SpecialInstruction}>{props.data.shipmentSpecialInstruction}</div>
              </Tooltip>
            </TableCell>
          </TableRow>}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default withStyles(styles)(ShipmentPopupInfo);